// extracted by mini-css-extract-plugin
export var animatedTextWrapperStyle = "animated_typewriter_text-module--animatedTextWrapperStyle--yNQQc";